import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import LayerFolder from "./components/LayerFolder";
import Folder from "./components/Folder";

import LayerScope from "./components/LayerScope";
import LayerLink from "./components/LayerLink";
import { ServerTypeHelper } from "../../_config/helpers";
import "./LayerSwitcher.css";

let folderIndex = 0;

const LayerSwitcher = (props) => {

  const { t } = useTranslation();

  const [layerTree, setLayerTree] = useState(null);

  const [hasVisibleLayers, setHasVisibleLayers] = useState(false);

  const sortAlphabetically = (tree) =>
    [...tree]
      .sort((a, b) =>
        (a.title || "").localeCompare(b.title || "", "pt-BR", {
          sensitivity: "base",
        })
      )
      .map((folder) => ({
        ...folder,
        subFolder: folder.subFolder
          ? sortAlphabetically(folder.subFolder)
          : null,
      }));

  useEffect(() => {
    if (!props.map) return;
    const sorted = sortAlphabetically(props.explorer);
    setLayerTree(buildFolderTree(sorted));
  }, [props.map, props.explorer]);

  const updateHasVisibleLayers = () => {
    const anyVisible = props.map
      .getLayers()
      .getArray()
      .some(
        (layer) =>
          layer.get("serverType") === ServerTypeHelper.GEOSERVER &&
          layer.getVisible()
      );

    setHasVisibleLayers(anyVisible);
  };


  useEffect(() => {
    if (!props.map) return;

    const layers = props.map.getLayers().getArray();

    const listeners = layers.map((layer) => {
      const fn = () => updateHasVisibleLayers();
      layer.on("change:visible", fn);
      return { layer, fn };
    });

    updateHasVisibleLayers();

    return () => {
      listeners.forEach(({ layer, fn }) => {
        layer.un("change:visible", fn);
      });
    };
  }, [props.map]);

  const layerSeqs = React.useMemo(() => {
    if (!props.map) return new Set();
    const seq = new Set();
    props.map
      .getLayers()
      .getArray()
      .forEach((l) => {
        const fs = l.get && l.get("folderSequence");
        if (fs) seq.add(fs);
      });
    return seq;
  }, [props.map]);


  const folderHasVisibleLayer = (folderSequence) => {
    return props.map
      .getLayers()
      .getArray()
      .some(
        (layer) =>
          layer.get("folderSequence")?.startsWith(folderSequence) &&
          layer.getVisible()
      );
  };


  const buildFolderTree = (tree) =>
    tree.map((folder) => {

      // Nó folha: só renderiza se tiver camadas cadastradas
      if (folder.subFolder == null) {
        if (!layerSeqs.has(folder.folderSequence)) return null;

        folderIndex += 1;
        return (
          <LayerFolder
            key={`folder.${folderIndex}`}
            folderSequence={folder.folderSequence}
            title={folder.title}
            map={props.map}
            folderIndex={folderIndex}
            hasNewVisibleLayer={props.hasNewVisibleLayer}
            sidebarVisible={props.visible}
          />
        );
      }

      folderIndex += 1;

      const hasLayersHere = layerSeqs.has(folder.folderSequence);

      // Verifica recursivamente se algum subFolder tem camadas
      const subFolderHasLayers = (subFolders) =>
        subFolders.some((sub) => {
          if (sub.subFolder == null) return layerSeqs.has(sub.folderSequence);
          return layerSeqs.has(sub.folderSequence) || subFolderHasLayers(sub.subFolder);
        });

      // Não renderiza pasta pai se não tiver nada dentro
      if (!hasLayersHere && !subFolderHasLayers(folder.subFolder)) return null;

      return (
        <Folder
          key={`folder.${folderIndex}`}
          title={folder.title}
          map={props.map}
          folderIndex={folderIndex}
          sidebarVisible={props.visible}
          hasVisibleLayer={folderHasVisibleLayer(folder.folderSequence)}
        >
          {hasLayersHere
            ? (() => {
              const innerIndex = ++folderIndex;
              return (
                <LayerFolder
                  key={`folder.${innerIndex}`}
                  folderSequence={folder.folderSequence}
                  title={`...`}
                  map={props.map}
                  folderIndex={innerIndex}
                  hasNewVisibleLayer={props.hasNewVisibleLayer}
                  inline={true}
                  activeVisible={props.activeVisible}
                />
              );
            })()
            : null}

          {buildFolderTree(folder.subFolder)}
        </Folder>
      );
    });

  const deactivateVisibleLayers = () => {
    props.map.getLayers().forEach((layer, i) => {
      if (
        layer.getVisible() &&
        layer.get("serverType") === ServerTypeHelper.GEOSERVER
      ) {
        layer.setVisible(false);
        document.getElementById("layer" + i).checked = false;
        props.hasNewVisibleLayer(-i);
      }
    });

    updateHasVisibleLayers();
  };




  return (
    <div
      id="navbarToggleExternalContent"
      className={`LayerSwitcher ${props.visible ? "active" : "hidden"}`}
    >
      <div className="p-4 LayerSwitcherExplorer">
        {/* título, escopo e categorias */}
        <div className="containerScope">
          <LayerScope currentLanguage={props.currentLanguage} map={props.map} />
          <span className="LayerSwitcherTitle">
            {t("layerSwitcher.categories")}
          </span>
        </div>
        <hr />

        {/* árvore */}
        <div className="LayerTree container">{layerTree}</div>

        <hr />

        {/* links utilitários */}
        <div className="container LayerSwitcherLinkWrapper">
          <LayerLink
            content={t("layerSwitcher.disableVisible")}

            checked={hasVisibleLayers}
            onToggle={deactivateVisibleLayers}
          />
        </div>

        {/*  <div className="container HeavyLinkWrapper">
          <HeavyLink
            btClass="btn btn-outline-light btn-lg"
            content={t('layerSwitcher.downloadData')}
            href="https://pedea.sema.ce.gov.br/geoserver/web/wicket/bookmarkable/org.geoserver.web.demo.MapPreviewPage"
          />
        </div>

        <br />

        <div className="container HeavyLinkWrapper">
          <HeavyLink
            btClass="btn btn-outline-light btn-lg"
            content={t('layerSwitcher.managerPortal')}
            href="https://pedea.sema.ce.gov.br/gestor"
          />
        </div> */}
      </div>
    </div>
  );
};

export default LayerSwitcher;
